import { render } from "./Academic.vue?vue&type=template&id=64dfe924"
import script from "./Academic.vue?vue&type=script&lang=js"
export * from "./Academic.vue?vue&type=script&lang=js"

import exportComponent from "/home/appfloretcollegein/app.floretcollege.in/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__